import { render, staticRenderFns } from "./Report2.vue?vue&type=template&id=53df5ff6&scoped=true&"
import script from "./Report2.vue?vue&type=script&lang=js&"
export * from "./Report2.vue?vue&type=script&lang=js&"
import style0 from "./Report2.vue?vue&type=style&index=0&id=53df5ff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53df5ff6",
  null
  
)

export default component.exports